(function () {
  var revealEls = document.querySelectorAll('.riwayat-reveal');
  if (revealEls.length) {
    var revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );
    revealEls.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  document.addEventListener(
    'pointermove',
    function (e) {
      var button = e.target instanceof Element ? e.target.closest('.button') : null;
      if (!button) return;
      var rect = button.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      button.style.setProperty('--riwayat-btn-x', x + '%');
      button.style.setProperty('--riwayat-btn-y', y + '%');
    },
    { passive: true }
  );

  document.addEventListener(
    'pointerdown',
    function (e) {
      var button = e.target instanceof Element ? e.target.closest('.button') : null;
      if (!button) return;
      var rect = button.getBoundingClientRect();
      var x = ((e.clientX - rect.left) / rect.width) * 100;
      var y = ((e.clientY - rect.top) / rect.height) * 100;
      button.style.setProperty('--riwayat-btn-x', x + '%');
      button.style.setProperty('--riwayat-btn-y', y + '%');
    },
    { passive: true }
  );

  if (!window.RIWAYAT || !window.RIWAYAT.sectionNavEnabled) return;

  var targets = Array.prototype.slice.call(document.querySelectorAll('[data-riwayat-nav-label]'));
  if (targets.length < 2) return;

  var nav = document.createElement('nav');
  nav.className = 'riwayat-section-nav';
  nav.setAttribute('aria-label', 'Section navigation');

  var buttons = targets.map(function (target, i) {
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'riwayat-section-nav__item';
    btn.setAttribute('aria-label', target.getAttribute('data-riwayat-nav-label'));
    btn.addEventListener('click', function () {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    nav.appendChild(btn);
    return btn;
  });

  document.body.appendChild(nav);

  var navObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var index = targets.indexOf(entry.target);
        if (index === -1) return;
        if (entry.isIntersecting) {
          buttons.forEach(function (b) {
            b.classList.remove('is-active');
          });
          buttons[index].classList.add('is-active');
        }
      });
    },
    { threshold: 0.5 }
  );

  targets.forEach(function (target) {
    navObserver.observe(target);
  });
})();
